const publicUrl = (typeof process.env.PUBLIC_URL === 'string' ? process.env.PUBLIC_URL : '').replace(
  /\/$/,
  '',
);

/** Kırık veya eksik ürün görselinde kullanılan site logosu (public/logo.png). */
export const MARKET_FALLBACK_IMAGE = publicUrl ? `${publicUrl}/logo.png` : '/logo.png';
